((root) => {
  const fields = ['model', 'case', 'band', 'bezelNh35', 'bezelNh34', 'dial', 'hands', 'movement', 'gmtColor', 'timeMode'];
  const optionKey = (state, group) => group === 'bezel' ? (state.movement === 'nh34' ? 'bezelNh34' : 'bezelNh35') : group;
  function shell(library, state, band) {
    const model = library.models[state.model];
    const caseId = model.bezelSelectsShell ? model.options.bezelNh35.find(b => b.id === state.bezelNh35)?.shellVariant : state.case;
    return band?.shellAssets ? band.shellAssets[caseId] : band?.asset;
  }
  function choices(library, state, group) {
    if (group === 'model') return library.models.subaquatic.options.model.map(item=>({...item}));
    const model = library.models[state.model];
    let options = model.options[optionKey(state,group)] || [];
    if (group === 'gmtColor' && state.movement !== 'nh34') return [];
    if (group === 'band') options = options.filter(b => Boolean(shell(library,state,b)));
    return options;
  }
  function normalize(library, value = {}) {
    if(!value||typeof value!=='object')value={};
    const model = Object.hasOwn(library.models,value.model) ? value.model : 'subaquatic';
    const result = {...library.models[model].defaults, model};
    for (const key of fields) if (typeof value[key] === 'string' && value[key].length < 80) result[key] = value[key];
    result.model = model;
    result.timeMode = value.timeMode === 'showroom' ? 'showroom' : 'live';
    for (const key of ['movement','case','bezelNh35','bezelNh34','dial','hands','gmtColor']) {
      const list = library.models[model].options[key] || [];
      result[key] = list.some(o=>o.id===result[key]) ? result[key] : (list[0]?.id || 'none');
    }
    const modelSpec = library.models[model];
    if (modelSpec.bandFollowsCase) {
      result.band = modelSpec.options.band.find(b=>shell(library,result,b))?.id || result.band;
    }
    const bands = choices(library,result,'band');
    if (!bands.some(b=>b.id===result.band)) result.band=bands[0]?.id || 'none';
    return result;
  }
  function encode(state) {
    const minimal = Object.fromEntries(fields.filter(k=>typeof state[k]==='string').map(k=>[k,state[k]]));
    return btoa(JSON.stringify({v:131,s:minimal})).replaceAll('+','-').replaceAll('/','_').replace(/=+$/,'');
  }
  function decode(value) {
    if (typeof value !== 'string' || value.length > 1800 || !/^[a-zA-Z0-9_-]+$/.test(value)) return null;
    try { const parsed=JSON.parse(atob(value.replaceAll('-','+').replaceAll('_','/'))); return parsed.v===131 && parsed.s && typeof parsed.s==='object' && !Array.isArray(parsed.s) ? parsed.s : null; } catch {return null;}
  }
  function url(value, state) {
    const link = new URL(value);
    link.searchParams.set('ew_design',encode(state));
    link.hash='';
    return link.href;
  }
  function geometry(library,kind,asset) {
    const base=library.canvas.geometry[kind] || {};
    const tuned=library.calibration[`${kind}:${asset || 'default'}`] || {};
    return {scale:1,x:0,y:0,originX:library.canvas.handAssetOriginX,originY:library.canvas.handAssetOriginY,...base,...tuned};
  }
  function migrate(value) {
    if(!value||typeof value!=='object')return null;
    if(!value.bezel)return value;
    const map={subSteel:'steel',speedSteel:'speedster-steel',nobileIntegratedCase:'nobile-steel',nobileSteel:'nobile-steel',nobileRose:'nobile-rose',subBlack:'black',subBlueDial:'blue',subGreenDial:'green',speedPanda:'speedster-panda',speedBlack:'speedster-black',speedIce:'speedster-ice-blue',nobileSunset:'nobile-sunset',nobileLime:'nobile-lime',nobilePink:'nobile-pink',nobileIce:'nobile-ice-blue',subBlackSilver:'black',subBlue:'blue',subGreen:'green',subIce:'ice',subOrange:'orange',subPink:'pink',subGmtBatman:'batman',subGmtBlack:'black-gmt',subGmtPepsi:'pepsi',subGmtCoke:'coke',subGmtSprite:'sprite',subGmtBluePurple:'blue-purple',speedFixed:'speedster-fixed',nobileIntegratedFixed:'nobile-fixed',subMercedes:'mercedes',subSnowflake:'snowflake',speedChronograph:'speedster-chronograph',nobileBaton:'nobile-baton',gmtRed:'red',gmtGreen:'green',gmtBlue:'blue',gmtOrange:'orange',rubberBlack:'rubber-black',rubberNavy:'rubber-navy',rubberGreen:'rubber-green',rubberIce:'rubber-ice',rubberOrange:'rubber-orange',rubberPink:'rubber-pink',nobileIntegratedBand:'nobile-integrated'};
    map.subGmtBlack='black';map.subGmtBluePurple='purple-black';map.rubberIce='rubber-turquoise';
    const result={...value,timeMode:'live'};
    for(const key of ['case','dial','hands','gmtColor','band'])result[key]=map[value[key]]||value[key];
    result[value.movement==='nh34'?'bezelNh34':'bezelNh35']=map[value.bezel]||value.bezel;
    if(value.model==='speedster'&&['oyster','jubilee','rubber-black'].includes(result.band))result.band='speedster-'+result.band;
    return result;
  }
  function productMatch(state,products) {
    if(!state || !Array.isArray(products))return null;
    const keys=['model','case','band','dial','hands','movement',optionKey(state,'bezel')];
    if(state.movement==='nh34')keys.push('gmtColor');
    return products.find(product=>product?.url && product.state && keys.every(key=>typeof state[key]==='string' && state[key]===product.state[key])) || null;
  }
  const api={fields,optionKey,shell,choices,normalize,encode,decode,url,geometry,migrate,productMatch};
  root.EdelmanDesignCore=api;
  if(typeof module!=='undefined') module.exports=api;
})(typeof globalThis!=='undefined'?globalThis:window);
